import { AxiosGetType, AxiosPostType } from '../../../context/FetchProvider';
import { RepetitionSettingsFetchI, RepetitionSettingsFormI } from './types';

/**
 * FetchRepetitionSettings.
 */
export const fetchRepetitionSettings = (
  get: AxiosGetType,
): Promise<RepetitionSettingsFormI> => {
  return get<RepetitionSettingsFetchI>('/repetitionOverride').then(
    ({
      data: {
        current: { c, i, f = 0 },
      },
    }) => ({
      correctHigh: c?.high || 'osmosis',
      correctLow: c?.low || 'osmosis',
      correctMed: c?.med || 'osmosis',
      incorrectHigh: i?.high || 'osmosis',
      incorrectMed: i?.med || 'osmosis',
      incorrectLow: i?.low || 'osmosis',
      flaggedOnly: !!f,
    }),
  );
};

/**
 * UpdateRepetitionSettings.
 */
export const updateRepetitionSettings =
  (post: AxiosPostType) => (values: RepetitionSettingsFormI) => {
    return post('/repetitionOverride', {
      correct: {
        high: values.correctHigh,
        med: values.correctMed,
        low: values.correctLow,
      },
      incorrect: {
        high: values.incorrectHigh,
        med: values.incorrectMed,
        low: values.incorrectLow,
      },
      flaggedOnly: values.flaggedOnly ? 1 : 0,
    });
  };
